<template>
  <div class="customers-page">
    <!-- Header -->
    <div class="prov-header">
      <div>
        <span class="header-eyebrow">Gestion</span>
        <h2 class="header-title">Customers</h2>
      </div>
      <div class="header-actions">
        <button class="btn-prov btn-prov--primary" @click="toggleFormulario">
          <i :class="showForm ? 'fa-solid fa-xmark' : 'fa-solid fa-plus'"></i>
          {{ showForm ? 'Cerrar' : 'Nuevo customer' }}
        </button>
      </div>
    </div>

    <!-- KPI Strip -->
    <div class="kpi-strip">
      <div class="kpi-card">
        <span class="kpi-label">Total</span>
        <span class="kpi-value">{{ listCustomers.length }}</span>
        <span class="kpi-foot">customers</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Pedidos</span>
        <span class="kpi-value">{{ countPedidos }}</span>
        <span class="kpi-foot">en total</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Acceso web</span>
        <span class="kpi-value">{{ countWeb }}</span>
        <span class="kpi-foot">con acceso B2B</span>
      </div>
      <div class="kpi-card">
        <span class="kpi-label">Paises</span>
        <span class="kpi-value">{{ countPaises }}</span>
        <span class="kpi-foot">distintos</span>
      </div>
    </div>

    <!-- Formulario crear/editar -->
    <transition name="slide">
      <div class="form-card" v-if="showForm">
        <div class="form-card__header">
          <div class="form-card__icon" :class="customerSelected ? 'form-card__icon--warning' : 'form-card__icon--primary'">
            <i :class="customerSelected ? 'fa-solid fa-pen' : 'fa-solid fa-plus'"></i>
          </div>
          <div>
            <h3 class="form-card__title">{{ customerSelected ? 'Editar customer' : 'Nuevo customer' }}</h3>
            <p class="form-card__subtitle" v-if="customerSelected">Editando: {{ customerSelected.nombre }}</p>
          </div>
        </div>

        <!-- Datos del cliente -->
        <div class="form-section-title">Datos del cliente</div>
        <div class="form-grid">
          <div class="field field--span2">
            <label class="field__label">Company name</label>
            <b-form-input size="sm" placeholder="Nombre de la empresa" v-model="companyName" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Nombre</label>
            <b-form-input size="sm" placeholder="Nombre" v-model="nombre" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Apellidos</label>
            <b-form-input size="sm" placeholder="Apellidos" v-model="apellidos" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">NIF</label>
            <b-form-input size="sm" placeholder="NIF" v-model="nif" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">VAT number</label>
            <b-form-input size="sm" placeholder="VAT" v-model="vat" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Email</label>
            <b-form-input size="sm" placeholder="email@customer.com" v-model="email" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Telefono</label>
            <b-form-input size="sm" placeholder="+34..." v-model="telefono" class="field__input" />
          </div>
          <div class="field field--span2">
            <label class="field__label">Direccion</label>
            <b-form-input size="sm" placeholder="Direccion completa" v-model="direccion" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">C.P.</label>
            <b-form-input size="sm" placeholder="Codigo postal" v-model="cp" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Ciudad</label>
            <b-form-input size="sm" placeholder="Ciudad" v-model="ciudad" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Pais</label>
            <b-form-input size="sm" placeholder="Pais" v-model="pais" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Categoria</label>
            <v-select v-model="categoria" :options="['A', 'B', 'C']" placeholder="Sin categoria" class="select-styled" />
          </div>
          <div class="field field--span2">
            <label class="field__label">Web</label>
            <b-form-input size="sm" placeholder="https://..." v-model="web" class="field__input" />
          </div>
          <div class="field field--span2">
            <label class="field__label">Social media</label>
            <b-form-input size="sm" placeholder="@usuario / enlaces" v-model="redes" class="field__input" />
          </div>
          <div class="field field--span2">
            <label class="field__label">Notas</label>
            <b-form-textarea size="sm" rows="2" placeholder="Notas internas" v-model="notas" class="field__input" />
          </div>
          <div class="field field--span2">
            <label class="field__label">Observaciones</label>
            <b-form-textarea size="sm" rows="2" placeholder="Observaciones" v-model="observaciones" class="field__input" />
          </div>
        </div>

        <!-- Direccion de envio -->
        <div class="form-section-title form-section-title--toggle">
          <span>Direccion de envio</span>
          <b-form-checkbox v-model="envio.activo" switch>
            La direccion de envio es diferente
          </b-form-checkbox>
        </div>
        <div class="form-grid" v-if="envio.activo">
          <div class="field">
            <label class="field__label">Nombre (envio)</label>
            <b-form-input size="sm" placeholder="Nombre destinatario" v-model="envio.nombre" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Empresa (envio)</label>
            <b-form-input size="sm" placeholder="Empresa" v-model="envio.empresa" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Telefono (envio)</label>
            <b-form-input size="sm" placeholder="+34..." v-model="envio.telefono" class="field__input" />
          </div>
          <div class="field field--span2">
            <label class="field__label">Direccion (envio)</label>
            <b-form-input size="sm" placeholder="Direccion completa" v-model="envio.direccion" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">C.P. (envio)</label>
            <b-form-input size="sm" placeholder="Codigo postal" v-model="envio.cp" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Ciudad (envio)</label>
            <b-form-input size="sm" placeholder="Ciudad" v-model="envio.ciudad" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Pais (envio)</label>
            <b-form-input size="sm" placeholder="Pais" v-model="envio.pais" class="field__input" />
          </div>
        </div>

        <!-- Condiciones de proforma por defecto -->
        <div class="form-section-title">Condiciones de proforma</div>
        <div class="form-grid">
          <div class="field">
            <label class="field__label">Resto pagadero en (dias)</label>
            <b-form-input size="sm" type="number" min="1" placeholder="30" v-model="proforma.restanteDias" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Validez (dias)</label>
            <b-form-input size="sm" type="number" min="1" placeholder="7" v-model="proforma.validezDias" class="field__input" />
          </div>
          <div class="field">
            <label class="field__label">Incoterms</label>
            <b-form-input size="sm" placeholder="DPD" v-model="proforma.incoterms" class="field__input" />
          </div>
          <div class="field field--span2">
            <label class="field__label">Payment terms</label>
            <b-form-input size="sm" placeholder="70% Advance Payment" v-model="proforma.paymentTerms" class="field__input" />
          </div>
        </div>
        <p class="form-hint">
          Se aplican al crear una proforma para este cliente. En blanco = valores generales.
        </p>

        <div class="form-card__footer">
          <button v-if="customerSelected" class="btn-prov btn-prov--ghost" @click="limpiarFormulario()">
            Cancelar
          </button>
          <button
            class="btn-prov"
            :class="customerSelected ? 'btn-prov--warning' : 'btn-prov--primary'"
            @click="guardarCustomer()"
          >
            <i :class="customerSelected ? 'fa-solid fa-check' : 'fa-solid fa-plus'"></i>
            {{ customerSelected ? 'Actualizar' : 'Crear customer' }}
          </button>
        </div>
      </div>
    </transition>

    <!-- Listado -->
    <div class="list-card">
      <div class="list-card__header">
        <h3 class="list-card__title">Listado</h3>
        <div class="list-card__filters">
          <div class="filter-pills">
            <button
              v-for="cat in ['Todas', 'A', 'B', 'C']"
              :key="'cat' + cat"
              class="pill"
              :class="{ active: categoriaFiltro === cat }"
              @click="categoriaFiltro = cat"
            >{{ cat === 'Todas' ? 'Cat: Todas' : cat }}</button>
          </div>
          <div class="filter-pills">
            <button
              v-for="f in ['Todos', 'Con acceso', 'Sin acceso']"
              :key="'web' + f"
              class="pill"
              :class="{ active: webFiltro === f }"
              @click="webFiltro = f"
            ><i v-if="f !== 'Todos'" class="fa-solid fa-globe mr-25"></i>{{ f === 'Todos' ? 'Web: Todos' : f }}</button>
          </div>
          <div class="search-box">
            <i class="fa-solid fa-magnifying-glass search-box__icon"></i>
            <input
              type="text"
              class="search-box__input"
              placeholder="Buscar customer..."
              v-model="buscar"
            />
          </div>
        </div>
      </div>

      <div class="table-wrapper">
        <b-table
          :items="linesTable"
          :fields="columnasTable"
          class="mb-0"
          hover
          responsive
          show-empty
          :busy="cargando"
          empty-text="No se encontraron customers"
          sort-icon-left
          thead-class="table-head"
          tbody-tr-class="table-row"
        >
          <template #table-busy>
            <div class="tabla-cargando">
              <b-spinner class="mr-50" small /> Cargando customers…
            </div>
          </template>

          <template #cell(nombre)="data">
            <div class="cell-nombre cell-nombre--link" @click="verPerfil(data.item)" title="Ver perfil">
              <div>
                <span class="cell-nombre__name">{{ data.item.nombre }} {{ data.item.apellidos }}</span>
                <span class="cell-nombre__nick" v-if="data.item.companyName">{{ data.item.companyName }}</span>
              </div>
            </div>
          </template>

          <template #cell(email)="data">
            <span class="cell-mono">{{ data.item.email }}</span>
          </template>

          <template #cell(telefono)="data">
            <span class="cell-mono" v-if="data.item.telefono">{{ data.item.telefono }}</span>
            <span class="cell-muted" v-else>--</span>
          </template>

          <template #cell(categoria)="data">
            <span v-if="data.item.categoria" class="badge-cat" :class="`badge-cat--${String(data.item.categoria).toLowerCase()}`">
              {{ data.item.categoria }}
            </span>
            <span v-else class="cell-muted">--</span>
          </template>

          <template #cell(b2bActivo)="data">
            <span
              v-if="data.item.b2bActivo"
              class="badge-web"
              title="Tiene acceso a la web wholesale"
              @click="verPerfil(data.item)"
            ><i class="fa-solid fa-globe"></i></span>
            <span v-else class="cell-muted">--</span>
          </template>

          <template #cell(pedidosCount)="data">
            <span
              class="badge-pedidos"
              :class="{ 'badge-pedidos--cero': !Number(data.item.pedidosCount) }"
              @click="verPerfil(data.item)"
              title="Ver historial"
            >
              {{ data.item.pedidosCount || 0 }}
            </span>
          </template>

          <template #cell(creditoDisponible)="data">
            <div class="cell-credito" v-if="data.item.creditoDisponible">
              <span
                class="badge-credito"
                title="Ver sus créditos"
                @click="$router.push({ name: 'creditos', query: { cliente: data.item.id } })"
              >
                {{ data.item.creditoDisponible }}
              </span>
              <button
                class="action-btn action-btn--print"
                title="Ver sus créditos"
                @click="abrirCreditos(data.item)"
              >
                <i class="fa-solid fa-hand-holding-dollar"></i>
              </button>
            </div>
            <span v-else class="cell-muted">--</span>
          </template>

          <template #cell(acciones)="data">
            <div class="cell-actions">
              <button class="action-btn action-btn--view" @click="verPerfil(data.item)" title="Ver perfil">
                <i class="fa-solid fa-eye"></i>
              </button>
              <button class="action-btn action-btn--edit" @click="editarCustomer(data.item)" title="Editar">
                <i class="fa-solid fa-pen"></i>
              </button>
              <button class="action-btn action-btn--delete" @click="borrarCustomer(data.item)" title="Eliminar">
                <i class="fa-solid fa-trash"></i>
              </button>
            </div>
          </template>
        </b-table>
      </div>

      <div class="list-card__footer">
        <span class="footer-count">{{ linesTable.length }} customers</span>
      </div>
    </div>

    <!-- Modal de créditos -->
    <b-modal
      v-model="showCreditos"
      :title="creditosCliente ? `Créditos de ${creditosCliente.nombre || creditosCliente.companyName}` : 'Créditos de clientes'"
      size="lg"
      hide-footer
      centered
    >
      <div v-if="cargandoCreditos" class="text-center my-2">
        <b-spinner small class="mr-50" /> Cargando…
      </div>
      <div v-else-if="!creditosLista.length" class="text-center text-muted my-2">
        No hay créditos
      </div>
      <template v-else>
        <div class="cred-list">
          <div v-for="cr in creditosLista" :key="cr.id" class="cred-row">
            <div class="cred-row__info">
              <span class="cred-row__numero">{{ cr.numero }}</span>
              <small class="text-muted ml-50">{{ formatFechaCredito(cr.fecha) }}</small>
              <span class="cred-row__cliente d-block">{{ nombreClienteCredito(cr) }}</span>
            </div>
            <span class="cred-estado" :class="`cred-estado--${estadoCredito(cr).clase}`">
              {{ estadoCredito(cr).texto }}
            </span>
            <div class="cred-row__importes">
              <span class="cred-row__total">{{ cr.simbolo }}{{ Number(cr.total).toFixed(2) }}</span>
              <small v-if="Number(cr.gastado) > 0 && estadoCredito(cr).clase !== 'gastado'" class="cred-row__quedan">
                quedan {{ cr.simbolo }}{{ (Number(cr.total) - Number(cr.gastado)).toFixed(2) }}
              </small>
            </div>
            <button
              class="action-btn action-btn--print"
              title="Imprimir este crédito"
              :disabled="pdfCreditoId === cr.id"
              @click="imprimirCredito(cr)"
            >
              <b-spinner v-if="pdfCreditoId === cr.id" small />
              <i v-else class="fa-solid fa-print"></i>
            </button>
          </div>
        </div>

        <div class="cred-footer">
          <span class="footer-count">{{ creditosLista.length }} créditos · {{ creditosDisponiblesCount }} con saldo</span>
          <button
            class="btn-prov btn-prov--primary"
            :disabled="pdfNoGastados || !creditosDisponiblesCount"
            @click="imprimirNoGastados"
          >
            <b-spinner v-if="pdfNoGastados" small />
            <i v-else class="fa-solid fa-print"></i>
            Imprimir no gastados
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BCard, BCardBody, BCardText, BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BButton, BTable, BFormCheckbox, BSpinner } from 'bootstrap-vue'
import axios from '@axios'
import vSelect from 'vue-select'

export default {
  components: {
    BCard,
    BCardBody,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BTable,
    BFormCheckbox,
    BSpinner,
    vSelect
  },
  data(){
    return{
      // Datos del cliente (mismos que en /escaner)
      companyName: "",
      nombre: "",
      apellidos: "",
      nif: "",
      vat: "",
      email: "",
      telefono: "",
      direccion: "",
      cp: "",
      ciudad: "",
      pais: "",
      web: "",
      redes: "",
      notas: "",
      observaciones: "",
      empresa: "Harber London",
      categoria: null,
      // Direccion de envio
      envio: {
        activo: false,
        nombre: "",
        empresa: "",
        telefono: "",
        direccion: "",
        cp: "",
        ciudad: "",
        pais: ""
      },
      // Condiciones de proforma por defecto del cliente
      proforma: {
        restanteDias: "",
        validezDias: "",
        incoterms: "",
        paymentTerms: ""
      },
      buscar: "",
      cargando: true,
      showForm: false,
      columnasTable: [
        { key: "nombre", label: "Customer", sortable: true },
        { key: "email", label: "Email", sortable: true },
        { key: "telefono", label: "Telefono", sortable: true },
        { key: "categoria", label: "Cat.", sortable: true, thStyle: { width: '60px' } },
        { key: "b2bActivo", label: "Web", sortable: true, thStyle: { width: '60px' } },
        { key: "pedidosCount", label: "Pedidos", sortable: true, thStyle: { width: '90px' } },
        { key: "creditoDisponible", label: "Crédito", thStyle: { width: '110px' } },
        { key: "acciones", label: "", thStyle: { width: '120px' } },
      ],
      linesTable: [],
      customerSelected: null,
      listCustomers: [],
      // Modal de créditos
      showCreditos: false,
      creditosCliente: null,
      creditosLista: [],
      cargandoCreditos: false,
      pdfCreditoId: null,
      pdfNoGastados: false,
      categoriaFiltro: "Todas",
      webFiltro: "Todos",
    }
  },
  computed: {
    creditosDisponiblesCount() {
      return this.creditosLista.filter(cr => Number(cr.total) - (Number(cr.gastado) || 0) > 0).length
    },
    countWeb() {
      return this.listCustomers.filter(p => !!p.b2bActivo).length
    },
    countPedidos() {
      return this.listCustomers.reduce((acc, p) => acc + (Number(p.pedidosCount) || 0), 0)
    },
    countPaises() {
      const paises = new Set()
      this.listCustomers.forEach(p => {
        if (p.pais) paises.add(p.pais.toLowerCase().trim())
      })
      return paises.size
    }
  },
  methods:{
    getColor(color) {
      const colors = {
        primary: '#3B82F6',
        secondary: '#64748B',
        success: '#10B981',
        danger: '#EF4444',
        warning: '#F59E0B',
        info: '#06B6D4'
      }
      return colors[color] || colors.primary
    },
    toggleFormulario() {
      if (this.showForm) {
        this.limpiarFormulario()
      }
      this.showForm = !this.showForm
    },
    load(){
      axios.post("/uso", {seccion:"customers"});
      this.cargando = true;
      axios
        .get("/customers")
        .then(response => {
            return response.data;
        })
        .then(res => {
          this.listCustomers = res;
          this.linesTable = res;
        })
        .finally(() => { this.cargando = false; });
    },
    construirInfo(){
      return {
        empresa: this.empresa,
        companyName: this.companyName,
        nombre: this.nombre,
        apellidos: this.apellidos,
        nif: this.nif,
        vat: this.vat,
        email: this.email,
        telefono: this.telefono,
        direccion: this.direccion,
        cp: this.cp,
        ciudad: this.ciudad,
        pais: this.pais,
        web: this.web,
        redes: this.redes,
        notas: this.notas,
        observaciones: this.observaciones,
        envioActivo: this.envio.activo ? 1 : 0,
        envioNombre: this.envio.nombre,
        envioEmpresa: this.envio.empresa,
        envioTelefono: this.envio.telefono,
        envioDireccion: this.envio.direccion,
        envioCp: this.envio.cp,
        envioCiudad: this.envio.ciudad,
        envioPais: this.envio.pais,
        color: 'primary',
        categoria: this.categoria || null
      }
    },
    // Guarda las condiciones de proforma del cliente y las refleja en el objeto local
    guardarProformaDefaults(id, info) {
      if (!id) return Promise.resolve();
      info.proformaRestanteDias = this.proforma.restanteDias || null;
      info.proformaValidezDias = this.proforma.validezDias || null;
      info.proformaIncoterms = this.proforma.incoterms || null;
      info.proformaPaymentTerms = this.proforma.paymentTerms || null;
      return axios
        .put(`/customers/${id}/proforma-defaults`, this.proforma)
        .catch(() => {
          this.$swal.fire('Error', 'No se pudieron guardar las condiciones de proforma', 'error');
        });
    },
    guardarCustomer(){
      let info = this.construirInfo();

      if(this.customerSelected == null)
      {
        axios
          .post("/customers", info)
          .then(response => {
              return response.data;
          })
          .then(res => {
            if (res && res.id) info.id = res.id;
            return this.guardarProformaDefaults(info.id, info);
          })
          .then(() => {
            this.listCustomers.push(info);
            this.buscarFuncion();
            this.limpiarFormulario();
            this.showForm = false;
          });
      }
      else
      {
        info.id = this.customerSelected.id;

        axios
          .post("/customers/update", info)
          .then(response => {
              return response.data;
          })
          .then(res => {
            return this.guardarProformaDefaults(info.id, info);
          })
          .then(() => {
            this.listCustomers.forEach(cust => {
              if(cust.id == info.id)
              {
                Object.assign(cust, info);
              }
            });
            this.buscarFuncion();
            this.limpiarFormulario();
            this.showForm = false;
          });
      }
    },
    verPerfil(data)
    {
      this.$router.push({ name: 'customer-profile', params: { id: data.id } });
    },
    abrirCreditos(customer = null)
    {
      this.creditosCliente = customer;
      this.showCreditos = true;
      this.cargandoCreditos = true;
      const url = customer ? `/customers/${customer.id}/creditos` : '/customers/creditos';
      axios
        .get(url)
        .then(({ data }) => { this.creditosLista = data || []; })
        .catch(() => { this.creditosLista = []; })
        .finally(() => { this.cargandoCreditos = false; });
    },
    nombreClienteCredito(cr)
    {
      if (this.creditosCliente) {
        const c = this.creditosCliente;
        return c.companyName || [c.nombre, c.apellidos].filter(Boolean).join(' ') || c.email || '—';
      }
      return cr.companyName || [cr.nombre, cr.apellidos].filter(Boolean).join(' ') || cr.email || '—';
    },
    formatFechaCredito(f)
    {
      if (!f) return '';
      const d = new Date(f);
      return Number.isNaN(d.getTime()) ? f : d.toLocaleDateString('es-ES');
    },
    estadoCredito(cr)
    {
      const total = Number(cr.total) || 0;
      const gastado = Number(cr.gastado) || 0;
      if (gastado >= total) return { texto: 'Gastado', clase: 'gastado' };
      if (gastado > 0) return { texto: 'Parcial', clase: 'parcial' };
      return { texto: 'Disponible', clase: 'disponible' };
    },
    imprimirCredito(cr)
    {
      this.pdfCreditoId = cr.id;
      axios
        .get(`/customers/creditos/${cr.id}/pdf`, { responseType: 'blob' })
        .then(({ data }) => {
          const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
          window.open(url, '_blank');
        })
        .catch(() => {
          this.$swal.fire('Error', 'No se pudo generar el PDF', 'error');
        })
        .finally(() => { this.pdfCreditoId = null; });
    },
    imprimirNoGastados()
    {
      this.pdfNoGastados = true;
      axios
        .get('/customers/creditos/pdf/todos', {
          responseType: 'blob',
          params: {
            soloDisponibles: 1,
            customerId: (this.creditosCliente && this.creditosCliente.id) || undefined,
          },
        })
        .then(({ data }) => {
          const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
          window.open(url, '_blank');
        })
        .catch(() => {
          this.$swal.fire('Error', 'No se pudo generar el PDF', 'error');
        })
        .finally(() => { this.pdfNoGastados = false; });
    },
    editarCustomer(data){
      this.companyName = data.companyName;
      this.nombre = data.nombre;
      this.apellidos = data.apellidos;
      this.nif = data.nif;
      this.vat = data.vat;
      this.email = data.email;
      this.telefono = data.telefono;
      this.direccion = data.direccion;
      this.cp = data.cp;
      this.ciudad = data.ciudad;
      this.pais = data.pais;
      this.web = data.web;
      this.redes = data.redes;
      this.notas = data.notas;
      this.observaciones = data.observaciones;
      this.empresa = data.empresa;
      this.categoria = data.categoria || null;

      this.envio = {
        activo: data.envioActivo == 1,
        nombre: data.envioNombre || "",
        empresa: data.envioEmpresa || "",
        telefono: data.envioTelefono || "",
        direccion: data.envioDireccion || "",
        cp: data.envioCp || "",
        ciudad: data.envioCiudad || "",
        pais: data.envioPais || ""
      };

      this.proforma = {
        restanteDias: data.proformaRestanteDias != null ? data.proformaRestanteDias : "",
        validezDias: data.proformaValidezDias != null ? data.proformaValidezDias : "",
        incoterms: data.proformaIncoterms || "",
        paymentTerms: data.proformaPaymentTerms || ""
      };

      this.customerSelected = data;
      this.showForm = true;

      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    limpiarFormulario(){
      this.companyName = "";
      this.nombre = "";
      this.apellidos = "";
      this.nif = "";
      this.vat = "";
      this.email = "";
      this.telefono = "";
      this.direccion = "";
      this.cp = "";
      this.ciudad = "";
      this.pais = "";
      this.web = "";
      this.redes = "";
      this.notas = "";
      this.observaciones = "";
      this.empresa = "Harber London";
      this.categoria = null;
      this.envio = {
        activo: false, nombre: "", empresa: "", telefono: "",
        direccion: "", cp: "", ciudad: "", pais: ""
      };
      this.proforma = {
        restanteDias: "", validezDias: "", incoterms: "", paymentTerms: ""
      };
      this.customerSelected = null;
    },
    buscarFuncion(){
      const q = this.buscar.toLowerCase();
      this.linesTable = [];

      this.listCustomers.forEach(cust => {
        const campos = [
          cust.nombre, cust.apellidos, cust.companyName, cust.email,
          cust.telefono, cust.nif, cust.vat, cust.ciudad, cust.pais, cust.web
        ];
        const coincide = campos.some(c => c != null && c.toString().toLowerCase().includes(q));

        const pasaCategoria = this.categoriaFiltro === "Todas" || cust.categoria === this.categoriaFiltro;
        const pasaWeb = this.webFiltro === "Todos"
          || (this.webFiltro === "Con acceso" ? !!cust.b2bActivo : !cust.b2bActivo);
        if (coincide && pasaCategoria && pasaWeb) this.linesTable.push(cust);
      });
    },
    borrarCustomer(item) {
      this.$swal.fire({
        title: 'Eliminar customer',
        text: `Se eliminara "${item.nombre || item.companyName}".`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        customClass: {
              cancelButton: 'btn btn-primary ml-1',
              confirmButton: 'btn btn-outline-danger eliminar-btn',
          },
      }).then((result) => {
        if (result.isConfirmed) {
            axios
              .post("/customers/delete", item )
              .then(response => {
                  return response.data;
              })
              .then(res => {
                  this.listCustomers = this.listCustomers.filter(p => p.id !== item.id);
                  this.linesTable = this.linesTable.filter(p => p.id !== item.id);

                  this.$swal.fire(
                    'Eliminado',
                    `El customer "${item.nombre || item.companyName}" fue eliminado.`,
                    'success'
                  );
              });
        }
      });
    }
  },
  mounted() {
    this.load();
  },
  watch: {
      buscar(){
        this.buscarFuncion();
      },
      categoriaFiltro(){
        this.buscarFuncion();
      },
      webFiltro(){
        this.buscarFuncion();
      },
  }
}
</script>

<style lang="scss" scoped>
$primary: #3B82F6;
$primary-dark: #2563EB;
$success: #10B981;
$danger: #EF4444;
$warning: #F59E0B;
$info: #06B6D4;
$border: #E2E8F0;
$text: #1E293B;
$text-muted: #64748B;
$bg: #F8FAFC;
$card-bg: #FFFFFF;
$radius: 12px;
$radius-sm: 8px;
$shadow: 0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04);

.customers-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 8px;
}

// Header
.prov-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 20px;
}

.header-eyebrow {
  display: block;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: $primary;
  margin-bottom: 2px;
}

.header-title {
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: $text;
  margin: 0;
}

// KPI Strip
.kpi-strip {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.kpi-card {
  background: $card-bg;
  border: 1px solid $border;
  border-radius: $radius-sm;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  box-shadow: $shadow;
}

.kpi-label {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: $text-muted;
}

.kpi-value {
  font-family: 'JetBrains Mono', monospace;
  font-size: 22px;
  font-weight: 700;
  color: $text;
  font-feature-settings: "tnum";
  margin: 4px 0 2px;
}

.kpi-foot {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  color: $text-muted;
}

// Buttons
.btn-prov {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 20px;
  border-radius: $radius-sm;
  border: none;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &--primary {
    background: $primary;
    color: white;
    &:hover { background: $primary-dark; }
  }

  &--warning {
    background: $warning;
    color: white;
    &:hover { background: darken($warning, 8%); }
  }

  &--ghost {
    background: transparent;
    color: $text-muted;
    &:hover { background: $bg; color: $text; }
  }

  &:disabled { opacity: 0.6; cursor: default; }
}

// Modal de créditos
.cred-list {
  max-height: 420px;
  overflow-y: auto;
}

.cred-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px 4px;
  border-bottom: 1px solid $border;

  &:last-child { border-bottom: none; }

  &__info { flex: 1; min-width: 0; }

  &__numero {
    font-family: 'JetBrains Mono', monospace;
    font-weight: 700;
    color: $text;
  }

  &__cliente {
    font-size: 13px;
    font-weight: 600;
    color: $text-muted;
  }

  &__importes {
    text-align: right;
    min-width: 90px;
  }

  &__total {
    font-family: 'JetBrains Mono', monospace;
    font-weight: 700;
    color: $text;
  }

  &__quedan {
    display: block;
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    color: $warning;
  }
}

.cred-estado {
  padding: 3px 10px;
  border-radius: 20px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 700;

  &--disponible { background: rgba($success, 0.1); color: $success; }
  &--parcial { background: rgba($warning, 0.12); color: darken($warning, 8%); }
  &--gastado { background: rgba($text-muted, 0.1); color: $text-muted; }
}

.cred-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
  margin-top: 6px;
  border-top: 1px solid $border;
}

// Form Card
.form-card {
  background: $card-bg;
  border: 1px solid $border;
  border-radius: $radius;
  box-shadow: $shadow;
  margin-bottom: 20px;
  overflow: hidden;

  &__header {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 22px 24px 0;
  }

  &__icon {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    flex-shrink: 0;

    &--primary { background: rgba($primary, 0.1); color: $primary; }
    &--warning { background: rgba($warning, 0.1); color: $warning; }
  }

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: $text;
    margin: 0;
  }

  &__subtitle {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    color: $text-muted;
    margin: 2px 0 0;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 0 24px 20px;
  }
}

.form-section-title {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: $primary;
  padding: 18px 24px 0;

  &--toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid $border;
    margin-top: 6px;
    padding-top: 18px;
  }
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  padding: 14px 24px;
}

.form-hint {
  font-size: 12px;
  color: #94A3B8;
  padding: 0 24px;
  margin: -2px 0 10px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 5px;

  &--span2 { grid-column: span 2; }

  &__label {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: $text-muted;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &__input {
    border-radius: 8px !important;
    border: 1px solid $border !important;
    font-size: 13px !important;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &:focus {
      border-color: $primary !important;
      box-shadow: 0 0 0 3px rgba($primary, 0.1) !important;
    }
  }
}

.badge-color {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;

  &--primary { background: $primary; }
  &--secondary { background: #64748B; }
  &--success { background: $success; }
  &--danger { background: $danger; }
  &--warning { background: $warning; }
  &--info { background: $info; }
}

// Slide transition
.slide-enter-active, .slide-leave-active {
  transition: all 0.3s ease;
  max-height: 1600px;
  overflow: hidden;
}
.slide-enter, .slide-leave-to {
  max-height: 0;
  opacity: 0;
  margin-bottom: 0;
}

// List Card
.list-card {
  background: $card-bg;
  border: 1px solid $border;
  border-radius: $radius;
  box-shadow: $shadow;
  overflow: hidden;

  &__header {
    padding: 20px 22px;
    border-bottom: 1px solid $border;
  }

  &__title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 16px;
    font-weight: 700;
    color: $text;
    margin: 0 0 14px;
  }

  &__filters {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
  }

  &__footer {
    padding: 12px 22px;
    border-top: 1px solid $border;
  }
}

.badge-web {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: rgba($primary, 0.1);
  color: $primary;
  font-size: 12px;
  cursor: pointer;
}

.filter-pills {
  display: flex;
  gap: 6px;
}

.pill {
  padding: 5px 14px;
  border-radius: 20px;
  border: 1px solid $border;
  background: transparent;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 500;
  color: $text-muted;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: $primary;
    color: $primary;
  }

  &.active {
    background: $primary;
    border-color: $primary;
    color: white;
  }
}

.search-box {
  position: relative;
  width: 240px;

  &__icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: $text-muted;
    font-size: 12px;
  }

  &__input {
    width: 100%;
    padding: 7px 12px 7px 32px;
    border: 1px solid $border;
    border-radius: $radius-sm;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 13px;
    color: $text;
    background: transparent;
    transition: border-color 0.15s ease;

    &::placeholder { color: #CBD5E1; }
    &:focus { outline: none; border-color: $primary; }
  }
}

// Table
.table-wrapper {
  padding: 0;
}

// Los ::v-deep van bajo .customers-page a proposito: en la raiz, postcss-rtl + scoped generan [dir][data-v-xxx]
// y ninguna propiedad direccional (padding, margin...) llega a aplicarse.
.customers-page ::v-deep .table-head th {
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: $text-muted;
  border-top: none;
  border-bottom: 1px solid $border;
  padding: 10px 16px;
  background: transparent;
}

.customers-page ::v-deep .table-row td {
  padding: 12px 16px;
  vertical-align: middle;
  border-color: lighten($border, 3%);
  font-size: 13px;
}

.customers-page ::v-deep .table-row:hover td {
  background: $bg;
}

.cell-nombre {
  display: flex;
  align-items: center;
  gap: 10px;

  &--link {
    cursor: pointer;

    .cell-nombre__name {
      color: #7367f0; // mismo color de enlace que en /escaner/pedidos
    }
  }

  &__name {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 600;
    color: $text;
    display: block;
    line-height: 1.2;
  }

  &__nick {
    font-family: 'JetBrains Mono', monospace;
    font-size: 11px;
    color: $text-muted;
  }
}

.cell-mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: $text;
}

.cell-pais {
  font-size: 13px;
  color: $text;
}

.cell-muted {
  color: #CBD5E1;
  font-size: 12px;
}

.badge-empresa {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 10px;
  border-radius: 20px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;

  &--hb {
    background: rgba($primary, 0.1);
    color: $primary;
  }

  &--cl {
    background: rgba($success, 0.1);
    color: $success;
  }
}

// Categoria del cliente (A / B / C)
.badge-cat {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 700;

  &--a { background: rgba($success, 0.12); color: $success; }
  &--b { background: rgba($warning, 0.15); color: darken($warning, 8%); }
  &--c { background: rgba($text-muted, 0.12); color: $text-muted; }
}

.cell-credito {
  display: flex;
  align-items: center;
  gap: 4px;
}

.badge-credito {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 700;
  background: rgba($success, 0.1);
  color: $success;
  cursor: pointer;
}

.badge-pedidos {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  padding: 3px 10px;
  border-radius: 20px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  font-weight: 700;
  background: rgba(#7367f0, 0.1);
  color: #7367f0;
  cursor: pointer;

  &--cero {
    background: rgba($text-muted, 0.08);
    color: $text-muted;
  }
}

.tabla-cargando {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 0;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: $text-muted;
}

.cell-actions {
  display: flex;
  gap: 4px;
}

.action-btn {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  border: 1px solid transparent;
  background: transparent;
  color: $text-muted;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  font-size: 12px;

  &--view:hover,
  &--edit:hover {
    background: rgba($primary, 0.1);
    color: $primary;
    border-color: rgba($primary, 0.2);
  }

  &--print:hover {
    background: rgba($success, 0.1);
    color: $success;
    border-color: rgba($success, 0.2);
  }

  &--delete:hover {
    background: rgba($danger, 0.1);
    color: $danger;
    border-color: rgba($danger, 0.2);
  }
}

.footer-count {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: $text-muted;
}

// Responsive
@media (max-width: 768px) {
  .kpi-strip { grid-template-columns: repeat(2, 1fr); }
  .form-grid { grid-template-columns: 1fr 1fr; }
  .field--span2 { grid-column: span 2; }
  .prov-header { flex-direction: column; align-items: flex-start; gap: 12px; }
  .list-card__filters { flex-direction: column; align-items: flex-start; }
  .search-box { width: 100%; }
}

@media (max-width: 480px) {
  .form-grid { grid-template-columns: 1fr; }
  .field--span2 { grid-column: span 1; }
}
</style>

<style lang="scss">
@import '../@core/scss/vue/libs/vue-select.scss';

// Vue-select styled (unscoped)
.customers-page {
  .select-styled {
    .vs__dropdown-toggle {
      min-height: 31px;
      padding: 0 0 2px 0;
      border-radius: 8px;
      border: 1px solid #E2E8F0;
      transition: border-color 0.15s ease;
    }

    .vs__search {
      font-size: 13px;
      font-family: 'Plus Jakarta Sans', sans-serif;
    }

    &.vs--open .vs__dropdown-toggle {
      border-color: #3B82F6;
      box-shadow: 0 0 0 3px rgba(#3B82F6, 0.1);
    }
  }
}

.eliminar-btn {
  color: white !important;
}

// Dark mode
.dark-layout {
  .customers-page {
    .header-title { color: #E2E8F0; }

    .kpi-card { background: #1E293B; border-color: #334155; }
    .kpi-value { color: #F1F5F9; }

    .form-card { background: #1E293B; border-color: #334155; }
    .form-card__title { color: #E2E8F0; }
    .form-section-title--toggle { border-color: #334155; }

    .field__label { color: #94A3B8; }
    .field__input {
      background: #0F172A !important;
      border-color: #334155 !important;
      color: #E2E8F0 !important;
      &:focus { border-color: #3B82F6 !important; }
    }

    .list-card { background: #1E293B; border-color: #334155; }
    .list-card__header { border-color: #334155; }
    .list-card__title { color: #E2E8F0; }
    .list-card__footer { border-color: #334155; }

    .pill {
      border-color: #475569;
      color: #94A3B8;
      &:hover { border-color: #3B82F6; color: #3B82F6; }
      &.active { background: #3B82F6; border-color: #3B82F6; color: white; }
    }

    .search-box__input {
      border-color: #334155;
      color: #E2E8F0;
      &::placeholder { color: #475569; }
      &:focus { border-color: #3B82F6; }
    }

    .table-head th { color: #94A3B8; border-color: #334155; }
    .table-row td { border-color: #334155; }
    .table-row:hover td { background: rgba(255,255,255,0.03); }

    .cell-nombre__name { color: #E2E8F0; }
    .cell-nombre--link .cell-nombre__name { color: #7367f0; }
    .cell-mono { color: #E2E8F0; }
    .cell-pais { color: #E2E8F0; }

    .action-btn { color: #94A3B8; }

    .select-styled {
      .vs__dropdown-toggle { border-color: #334155; background: #0F172A; }
      .vs__search { color: #E2E8F0; }
    }
  }
}
</style>
